module.exports = __webpack_public_path__ + "static/media/creamydalmakhani.402ae411.jpg";